module.exports = __webpack_public_path__ + "media/images/emblems/Steinach-2a6303b9a7653d4a39325b8ce2b47d85.png";